import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Svg } from '../../Svg/Svg';

function Radio({
  id,
  label,
  name,
  value,
  errorMessage,
  onChange,
  checked,
  isDisabled,
  ...otherProps
}) {
  //const [radioDisabled] = useState(isDisabled);

  //console.log(radioDisabled)
  return (
    <div className={`mz-form-item mz-form-item--radio ${isDisabled ? 'disabled' : ''}`}>
      <label className="mz-form-item__inner" htmlFor={id}>
        <div className="mz-form-item__label-content">
          {label}
        </div>
        <input
          type="radio"
          className="mz-form-item__radio"
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          checked={checked}
          disabled={isDisabled ? "disabled" : ""}
          {...otherProps}
        />
        <div className="mz-form-item__checkmark">
          <Svg
            type="checkmark"
            size={1}
            colour="mz-svg--black"
          />
        </div>
        {errorMessage && (
          <div className="mz-form-item__error-message">{errorMessage}</div>
        )}
      </label>
    </div>
  )
}

Radio.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  otherProps: PropTypes.object,
}

export default Radio